import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Container
      maxWidth="md"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 100, color: 'primary.main' }} />
      </Box>

      <Typography variant="h2" component="h1" gutterBottom>
        404
      </Typography>
      <Typography variant="h5" color="textSecondary" gutterBottom>
        אופס... העמוד שאתה מחפש לא נמצא
      </Typography>
      <Typography variant="body1" color="textSecondary" mb={3}>
      ייתכן שהוא הועבר או נמחק.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        onClick={handleGoHome}
        sx={{
          mt: 2,
          px: 4,
          py: 1.5,
          fontSize: '1rem',
          fontWeight: 'bold',
        }}
      >
        חזרה לעמוד הבית
      </Button>
    </Container>
  );
};

export default NotFoundPage;
